import ApuracaoBase from './apuracao-base';
import ApuracaoPanoramaBase from './apuracao-panorama-base';
import WidgetApuracaoBase from './widget-apuracao-base';
import * as utils from './utils';

export default ApuracaoBase;
export {
  ApuracaoBase,
  ApuracaoPanoramaBase,
  WidgetApuracaoBase,
  utils
};
